module.exports = __webpack_public_path__ + "components/flag/static/square/cz-158aa72bc14d07df1aa729cc7399cc3c.svg";